import { createActionTypeModel } from "../../../../store/global/action-model";

export const InvoiceData = createActionTypeModel('InvoiceData');
export const InvoiceList = createActionTypeModel('InvoicesList');
export const InvoiceListFilter = createActionTypeModel('InvoiceListFilter');
export const SelectedInvoice = createActionTypeModel('SelectedInvoice');
export const InvoiceDetails = createActionTypeModel('InvoiceDetails');
export const ArtistPayments = createActionTypeModel('ArtistPayments');




export const FETCH_ONLY_INVOICE='FETCH_ONLY_INVOICE';
export const InvoiceLines = createActionTypeModel('InvoiceLines');
export const Payments = createActionTypeModel('Payments');
export const ForwardPayments = createActionTypeModel('ForwardPayments');

export const LOCK_INVOICE = 'LOCK_INVOICE';
export const UPDATE_VAT_NO = 'UPDATE_VAT_NO';
export const UPDATE_VAT_VALID = 'UPDATE_VAT_VALID';
export const CHANGE_TAX_DEDUC = 'CHANGE_TAX_DEDUC';

export const UPDATE_INVOICE_LIST_SCROLLTOP = 'UPDATE_INVOICE_LIST_SCROLLTOP';
